import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import ChangePassword from './pages/ChangePassword/ChangePassword';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#3C5CCB', contrastText: '#ffffff' },
    secondary: { main: '#64748B' },
    text: { primary: '#0F172A', secondary: '#475569' },
    background: { default: '#EEF2F8', paper: 'rgba(255,255,255,0.65)' },
  },
  shape: { borderRadius: 12 },
  typography: {
    body1: { fontSize: '14px', fontWeight: 400 },
    subtitle2: { fontWeight: 700, color: '#0F172A', fontSize: '14px' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: 'linear-gradient(135deg, #EDF2FF 0%, #F8FAFC 40%, #EEF2F8 100%)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
          boxShadow: '0 6px 16px rgba(60,92,203,0.18)',
        },
        containedPrimary: {
          background: 'linear-gradient(180deg,#3C5CCB 0%,#2E49A6 100%)',
        },
      },
    },
    MuiTextField: {
      defaultProps: { fullWidth: true, size: 'small' },
      styleOverrides: {
        root: {
          maxWidth: 500,
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            fontSize: '14px',
            background: 'rgba(255,255,255,0.7)',
            backdropFilter: 'blur(6px)',
          },
          '& .MuiOutlinedInput-input': {
            paddingTop: 10,
            paddingBottom: 10,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          background: 'rgba(255,255,255,0.6)',
          backdropFilter: 'saturate(180%) blur(12px)',
          border: '1px solid rgba(255,255,255,0.7)',
          boxShadow: '0 10px 30px rgba(16,24,40,0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          backdropFilter: 'none',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          backdropFilter: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/alterarsenha" replace />} />
          <Route path="/alterarsenha" element={<ChangePassword />} />
          <Route path="*" element={<Navigate to="/alterarsenha" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
